import React, { useEffect, useState } from 'react';
import { pricingService } from './pricingService';

export const DynamicPricingPanel: React.FC = () => {
  const [recommendations, setRecommendations] = useState<any[]>([]);
  const [experiments, setExperiments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const data = await pricingService.getPricingData();
      setRecommendations(data.recommendations);
      setExperiments(data.experiments);
    } catch (err) {
      console.error('Failed to fetch pricing data', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleApprove = async (recId: string) => {
    const reason = window.prompt('Provide a reason for approving this pricing change:');
    if (!reason) return;

    try {
      await pricingService.approveRecommendation(recId, reason);
      alert('Recommendation approved for next billing cycle.');
      fetchData();
    } catch (err: any) {
      alert('Approval failed: ' + (err.message || 'Error'));
    }
  };

  if (loading) return <div>Loading Dynamic Pricing Panel...</div>;

  return (
    <div className="module-pricing">
      <section className="experiments">
        <h3>Active Pricing Experiments</h3>
        <div className="experiment-grid">
          {experiments.map(exp => (
            <div key={exp.id} className="experiment-card">
              <h5>{exp.experiment_name}</h5>
              <div className="cohorts">
                {exp.cohorts.map((c: any) => (
                  <div key={c.name}>
                    Cohort {c.name}: {c.config.overage_rate}₹ (Margin: {c.margin_delta}%)
                  </div>
                ))}
              </div>
              <span className={`status ${exp.experiment_status.toLowerCase()}`}>
                {exp.experiment_status}
              </span>
            </div>
          ))}
        </div>
      </section>

      <section className="recommendations">
        <h3>Pricing & Tiering Recommendations</h3>
        <table>
          <thead>
            <tr>
              <th>Enterprise</th>
              <th>Segment</th>
              <th>Type</th>
              <th>Current</th>
              <th>Proposed</th>
              <th>ARR Uplift</th>
              <th>Confidence</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {recommendations.map(rec => (
              <tr key={rec.id}>
                <td>{rec.company_name}</td>
                <td>{rec.enterprise_segment}</td>
                <td>{rec.recommendation_type}</td>
                <td>{rec.current_value}</td>
                <td>{rec.recommended_value}</td>
                <td className="positive">+₹{rec.projected_arr_uplift}</td>
                <td>{(rec.confidence_score * 100).toFixed(0)}%</td>
                <td>
                  <button onClick={() => handleApprove(rec.id)} className="btn-approve">
                    Approve
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
};
